import createDvaApp from '@sisyphe/plugin-dva'

import history from './history'
import App from './app'
import { errorHandler } from 'utils/api/error-handler'
import 'antd-mobile/dist/antd-mobile.css'
import 'utils/gt.js'

const modelFiles = require.context(
  './models',
  false,
  /^\.\/[^/]+\.(js|ts|tsx)$/
)
const models = modelFiles.keys().map(key => modelFiles(key).default)

const { search } = window.location
window.sessionStorage.setItem('search', search)

export default createDvaApp(App, {
  history,
  models,
  onError: (err, dispatch) => {
    errorHandler(history)(err)
  },
})
